<template>
  <div style="position: relative">
    <div style="height: 100%"></div>
  </div>
</template>

<script>
export default {
  mounted() {

  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// app/pages/index.vue